import { GA_TRACKING_ID } from 'commons/constants/env'
import { UserProfile } from 'commons/types/user'
import gtag from './gtag'

const profileNames: { [K in UserProfile]: string } = {
  ADMIN: 'Administrador',
  ADMIN_MASTER: 'Administrador Master',
  PRODUTOR: 'Produtor',
  PRODUTOR_MUSICAL: 'Produtor Musical',
  PRODUTOR_ELENCO: 'Produtor de Elenco',
  GESTOR: 'Gestor',
}

function getProfileName(profiles: UserProfile[]) {
  return profiles
    .map(profile => profileNames[profile])
    .filter(Boolean)
    .join(' | ')
}

function isAdminOrMaster(profiles: UserProfile[]) {
  return profiles.some(profile => profile === 'ADMIN' || profile === 'ADMIN_MASTER')
}

/**
 * Allow set the gtag/ga user id
 */
function setGtagUser(userId?: number | null) {
  gtag('config', GA_TRACKING_ID, {
    user_id: userId,
  })
}

function setGtagLogin() {
  gtag('event', 'login')
}

function setGtagLoginError() {
  gtag('event', 'login_error')
}

export { setGtagUser, setGtagLogin, setGtagLoginError, getProfileName, isAdminOrMaster }
